module.exports = __webpack_public_path__ + "img/fig04.26e61557.jpg";